import { useEffect, useState } from "react";

const CustomHeader = (props) => {
  const { column, text } = props; // Pobranie text z propsów
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const updateHeader = () => {
      const colWidth = column.getActualWidth();
      setIsNarrow(colWidth < 90); // Sprawdzamy, czy kolumna jest wąska
    };

    updateHeader();
    column.addEventListener("widthChanged", updateHeader);

    return () => {
      column.removeEventListener("widthChanged", updateHeader);
    };
  }, [column]);

  return (
    <div className="custom-header">
      {isNarrow ? (
        <i className="fas fa-info-circle"></i> // Tylko ikona, gdy kolumna jest wąska
      ) : (
        <>
          <span className="header-text">{text}</span> {/* Tekst */}
          <i className="fas fa-info-circle" style={{ marginLeft: '8px' }}></i> {/* Ikona obok tekstu */}
        </>
      )}
    </div>
  );
};

export default CustomHeader;